const DEFAULT_DATA_LAYER = "dataLayer";

function getDataLayer(name) {
  const key = name || DEFAULT_DATA_LAYER;
  if (typeof window === "undefined") {
    return null;
  }
  window[key] = window[key] || [];
  return window[key];
}

function sendGTMEvent(data, dataLayerName) {
  const layer = getDataLayer(dataLayerName);
  if (!layer) {
    return;
  }
  layer.push(data);
}

module.exports = {
  sendGTMEvent,
};
